import { useEffect } from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import { useStores } from 'src/models';

/**
 * ## Custom Snackbar
 *
 */

function CSnackbar() {
  const { enqueueSnackbar } = useSnackbar();
  const { snackbarStore } = useStores();
  const { open, btnLabel, title, category, invokeOnClick, closeSnackbar } = snackbarStore;

  const handleOnClick = () => {
    invokeOnClick();
    closeSnackbar();
  };

  useEffect(() => {
    if (open) {
      enqueueSnackbar(title, {
        variant: category,
        onClose: handleOnClick,
        action: btnLabel && <Button onClick={handleOnClick}>{btnLabel}</Button>,
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      });
    }
  }, [open]);

  return null;
}

export default observer(CSnackbar);
